import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const walletUserUnlock = http.patch(
  createMockEndpoint('/wallet_user/:id/unlock'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
